export const TYPES = {
  GET_PAYOUT_STATUS_REQUEST: "GET_PAYOUT_STATUS_REQUEST",
  GET_PAYOUT_STATUS_SUCCESS: "GET_PAYOUT_STATUS_SUCCESS",
};
